(function bootstrapLahziBrowserRuntime(global) {
  'use strict';

  if (global.LahziRuntime) return;

  const memory = new Map();
  const once = new Map();

  function probeStorage(name) {
    try {
      const storage = global[name];
      const key = '__lahzi_probe__';
      storage.setItem(key, '1');
      storage.removeItem(key);
      return storage;
    } catch (_) {
      return null;
    }
  }

  const local = probeStorage('localStorage');
  const session = probeStorage('sessionStorage');

  function adapter(storage, namespace) {
    return {
      available: !!storage,
      get(key, fallback = null) {
        try {
          const value = storage ? storage.getItem(key) : memory.get(`${namespace}:${key}`);
          return value == null ? fallback : value;
        } catch (_) { return fallback; }
      },
      set(key, value) {
        try {
          if (storage) storage.setItem(key, String(value));
          else memory.set(`${namespace}:${key}`, String(value));
          return true;
        } catch (_) { return false; }
      },
      remove(key) {
        try {
          if (storage) storage.removeItem(key);
          memory.delete(`${namespace}:${key}`);
          return true;
        } catch (_) { return false; }
      },
      keys() {
        try {
          if (storage) return Array.from({ length: storage.length }, (_, index) => storage.key(index)).filter(Boolean);
          const prefix = `${namespace}:`;
          return Array.from(memory.keys()).filter(key => key.startsWith(prefix)).map(key => key.slice(prefix.length));
        } catch (_) { return []; }
      },
    };
  }

  const localStore = adapter(local, 'local');
  const sessionStore = adapter(session, 'session');

  function runOnce(key, factory) {
    if (!once.has(key)) once.set(key, Promise.resolve().then(factory));
    return once.get(key);
  }

  function createChannel(name) {
    let channel = null;
    const fallbackTarget = new EventTarget();
    try {
      if (typeof global.BroadcastChannel === 'function') channel = new global.BroadcastChannel(name);
    } catch (_) { channel = null; }
    return {
      postMessage(data) {
        if (channel) {
          try { channel.postMessage(data); return; } catch (_) { /* use fallback */ }
        }
        fallbackTarget.dispatchEvent(new MessageEvent('message', { data }));
      },
      addEventListener(type, listener) {
        try { (channel || fallbackTarget).addEventListener(type, listener); } catch (_) { /* optional feature */ }
      },
      removeEventListener(type, listener) {
        try { (channel || fallbackTarget).removeEventListener(type, listener); } catch (_) { /* optional feature */ }
      },
      close() { try { channel?.close(); } catch (_) { /* optional feature */ } },
      native: !!channel,
    };
  }

  function getDarkMode() {
    const stored = localStore.get('darkMode');
    if (stored !== null) {
      try { return JSON.parse(stored) === true; } catch (_) { /* fall through */ }
    }
    return false;
  }

  function setDarkMode(value) {
    localStore.set('darkMode', JSON.stringify(!!value));
  }

  global.LahziRuntime = Object.freeze({
    local: localStore,
    session: sessionStore,
    runOnce,
    createChannel,
    getDarkMode,
    setDarkMode,
    capabilities: Object.freeze({
      localStorage: !!local,
      sessionStorage: !!session,
      broadcastChannel: typeof global.BroadcastChannel === 'function',
      webLocks: !!global.navigator?.locks,
      cookiesEnabled: global.navigator?.cookieEnabled !== false,
    }),
  });

  global.lahziGetDarkMode = getDarkMode;
  global.lahziSetDarkMode = setDarkMode;
})(window);
